import { styled } from '@mui/material';

export const CardButtonStyled = styled(`button`)<{ isMobile: boolean; defaultCard?: boolean }>(
	({ isMobile, theme, defaultCard }) => ({
		width: !isMobile ? '250px' : '100%',
		height: '140px',
		backgroundColor: defaultCard === false ? 'rgba(254, 114, 35, 0.05)' : 'white',
		border: `2px solid ${theme.palette.primary.main}`,
		borderRadius: '10px',
		margin: '10px',
		cursor: 'pointer',
		display: defaultCard !== undefined ? 'flex' : 'block',
		flexDirection: defaultCard !== undefined ? 'column' : 'row',
		borderColor: defaultCard ? theme.palette.borders.primary : theme.palette.primary.main,
		padding: '10px',
	})
);
